import React, {useContext, useEffect, useRef, useState} from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import '../../../../css/qavaApp.css';

import { App_Footer } from '../components/App_Footer_ProService';
import { App_Header } from '../components/App_Header_ProService';
import { ShowPortfolioPicsModal } from './Modal_ShowPortfolioPics'

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';



 export function ViewPortfolioDetailDataModal (props) {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    let [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    let [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL] = useState(authenticatedMerchent_context.baseURL);
    
    let [portfolioID, setPortfolioID] = useState(null);
    let [portfolioPicsModal, setPortfolioPicsModal] = useState(false);
    let [viewPortfolioDetailsData, setViewPortfolioDetailsData] = useState([]);
    let [showPortfolioDetails, setShowPortfolioDetails] = useState(false);

    let [createPortfolioName, setCreatePortfolioName] = useState(null);
    let [createPortfolioDescription, setCreatePortfolioDescription] = useState(null);
    let [clientFirstName, setClientFirstName] = useState(null);
    let [clientLastName, setClientLastName] = useState(null);
    let [clientFeedback, setClientFeedback] = useState(null);


function getPortfolioDetailData(portfolioID) {

    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74308_portfolio_details',
            user: acctID,
            xPortfolioID: portfolioID,
            sessionID: sessionID,
        }),
    }

    
    fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');

        for (let rownum = 0; rownum < rows.length - 1; ++rownum)
        {
            let cols = rows[rownum].split('|');

            setPortfolioID(cols[1]);
            setCreatePortfolioName(cols[2]);
            setCreatePortfolioDescription(cols[3]);
            setClientFirstName(cols[4]);
            setClientLastName(cols[4]);
            setClientFeedback(cols[5]);

            setViewPortfolioDetailsData((prevViewInventoryPortfolioMainDetailsData) => {
                return prevViewInventoryPortfolioMainDetailsData.concat({
                    projectID: cols[0],
                    portfolioID: cols[1],
                    portfolioName: cols[2],
                    portfolioDescription: cols[3],
                    clientName: cols[4],
                    clientFeedback: cols[5],
                    dateLogged: cols[6],
                    portfolioPic1: cols[7],
                    portfolioPic2: cols[8],
                    portfolioPic3: cols[9],
                    portfolioPic4: cols[10],
                    portfolioPic5: cols[11],
                    portfolioPic6: cols[12],
                    portfolioPic7: cols[13],
                    portfolioPic8: cols[14],
                    portfolioStatus: cols[15],
                })
            });

        }
        
    })

}

function closeModalHandler() {

    props.closeModal(false);
}

useEffect(() =>  {

    //alert("In produt detals modal");
    //alert(props.data.portfolioID);

        
    getPortfolioDetailData(props.data.portfolioID); 

}, [])

            return(

                <React.Fragment>
                {props.openModal == true ?
                (
                <IonModal id='showPortfolioDetails' isOpen={ props.openModal}>
                        <IonHeader>
                            <IonGrid >
                                <IonRow>
                                            <IonCol >Portfolio ID</IonCol>
                                            <IonCol >Date Created</IonCol>
                                </IonRow>
                                {viewPortfolioDetailsData.map((detailData) =>   {
                                    return (
                                        <IonRow >
                                            <IonCol >{detailData.portfolioID}</IonCol>
                                            <IonCol >{detailData.dateLogged}</IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>
                        </IonHeader>
                        <IonContent className='bookedDetails_gridContent_multiple'>
                        <IonGrid>
                            <IonRow>
                                <IonCol>
                                    <IonSlides>
                                        <IonSlide>
                                        {viewPortfolioDetailsData.map((detailData) =>   {
                                            return (
                                            <IonGrid >
                                                <IonRow >
                                                    <IonCol size='6' >Category</IonCol>
                                                    <IonCol size='6' >Value</IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol size='6'>Porfolio Name</IonCol>
                                                    <IonCol size='6'>
                                                        <IonInput className='professional-input' type='text' value={createPortfolioName} placeholder='Enter Portfolio Name' autocomplete='off' onIonChange={(e) => setCreatePortfolioName(e.target.value)} required></IonInput>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol size='6'>Description</IonCol>
                                                    <IonCol size='6'>
                                                        <IonInput className='professional-input' type='text' value={createPortfolioDescription} placeholder='Enter Portfolio Name' autocomplete='off' onIonChange={(e) => setCreatePortfolioDescription(e.target.value)} required></IonInput>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol size='6'>Client Name</IonCol>
                                                    <IonCol size='6'>
                                                        <IonInput className='professional-input' type='text' value={clientFirstName} placeholder='Enter Portfolio Name' autocomplete='off' onIonChange={(e) => setCreatePortfolioName(e.target.value)} required></IonInput>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol size='6'>Client Feedback</IonCol>
                                                    <IonCol size='6'>
                                                        <IonInput className='professional-input' type='text' value={clientFeedback} placeholder='Enter Portfolio Name' autocomplete='off' onIonChange={(e) => setCreatePortfolioName(e.target.value)} required></IonInput>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow class='gridResultBody'>
                                                    <IonCol size='6' class='gridResultHeaders'>Portfolio Images</IonCol>
                                                    <IonCol size='6' class='gridResultColumns'>
                                                        <ShowPortfolioPicsModal openModal={ portfolioPicsModal } closeModal={() => setPortfolioPicsModal(false)} closeModal_2nd ={() => props.closeModal(false)} data={{
                                                        portfolioPic1: detailData.portfolioPic1, 
                                                        portfolioPic2: detailData.portfolioPic2, 
                                                        portfolioPic3: detailData.portfolioPic3, 
                                                        portfolioPic4: detailData.portfolioPic4, 
                                                        portfolioPic5: detailData.portfolioPic5, 
                                                        portfolioPic6: detailData.portfolioPic6, 
                                                        portfolioPic7: detailData.portfolioPic7, 
                                                        portfolioPic8: detailData.portfolioPic8, 
                                                        portfolioID: detailData.portfolioID, 
                                                        portfolioSalePrice: detailData.portfolioSalePrice
                                                        }}></ShowPortfolioPicsModal>
                                                        <IonButton class='gridResultColumnButton' onClick={() => setPortfolioPicsModal(true)}> View </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                            </IonGrid>
                                                    )
                                                }
                                            )}
                                            </IonSlide>
                                        </IonSlides>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                            </IonContent>
                            <IonButton className='button_closeModal_center' onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonModal>) : null}
                </React.Fragment>
            )
}   



export default ViewPortfolioDetailDataModal;